import * as z from 'zod'

export const updateProfileSchema = z.object({
  email: z.email(),
  username: z.string(),
  birthdate: z.union([z.string(), z.date()]),
  image: z.instanceof(File).or(z.null()).optional(),
})

export type UpdateProfileDto = z.infer<typeof updateProfileSchema>
